import { Mention } from "./mention";
import { Mentioning, MentioningFilterFactory } from "./mentioning";
import { Mentioned } from "./mentioned";
import { SuggestionsDropdownComponent } from "./suggestions-dropdown/suggestions-dropdown.component";

const mod = angular.module("mentions", ["ui.mention"]);

mod.component("suggestionsDropdown", SuggestionsDropdownComponent);

mod.directive("mention", Mention.factory());
mod.directive("mentioning", Mentioning.factory());
mod.directive("mentioned", Mentioned.factory());

mod.filter("mentioning", MentioningFilterFactory);

export default mod.name;
